import { render, staticRenderFns } from "./UsersSidebar.vue?vue&type=template&id=ef10faf4&scoped=true&"
import script from "./UsersSidebar.vue?vue&type=script&lang=js&"
export * from "./UsersSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UsersSidebar.vue?vue&type=style&index=0&id=ef10faf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef10faf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VDivider,VList,VListItem,VListItemContent,VNavigationDrawer})
